var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list_wrapper"},_vm._l((_vm.list),function(i,index){return _c('div',{key:i.id,staticClass:"list_wrapper-item",class:{active:_vm.nowClick===i.id },on:{"click":function($event){return _vm.handleItemClick(i)}}},[_vm._v("\n    "+_vm._s(i.name)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5baf4e23","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AIImport/selectItem.vue
// module id = null
// module chunks = 